const SOURCES = {
    "ACS": {
      "sourceName": "US Census Bureau",
      "datasetName": "American Community Survey (ACS) 5-Year Estimates",
      "datasetLink": "https://www.census.gov/data/developers/data-sets/acs-5year.html",
     
    }, 
    "BPS": {
      "sourceName": "US Census Bureau",
      "datasetName": "Building Permits Survey",
      "datasetLink": "https://www.census.gov/construction/bps/index.html",
    }
  }

const populationGrowthData = {
  aboutDescription: "This metric tracks the annual percentage change in the total population.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The annual increase in residents. Higher growth increases housing demand and can put pressure on avaialability and affordability if housing supply doesn't keep pace.",
  calculationFormula:
    "(Population in Current Year¹ - Population in Previous Year¹) / Population in Previous Year¹ * 100",
};


const newlyPermittedUnitsData = {
  aboutDescription: "This metric tracks the number of newly permitted housing units per 1,000 residents.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
    {
      sourceName: SOURCES["BPS"].sourceName,
      datasetName: SOURCES["BPS"].datasetName,
      datasetLink: SOURCES["BPS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "Newly Permitted Housing Units",
          commonName: "Newly Permitted Housing Units",
          url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
        },
      ],
    },
  ],
  metricDefinition: "The number of housing units approved for construction per 1,000 people. Indicates how actively a city is adding supply in response to population or market demand.",
  calculationFormula:
    "(Newly Permitted Housing Units²) / (Total Population¹ / 1000)",
};


const housingStockGrowthData = {
  aboutDescription: "This metric tracks the annual percentage growth of the housing stock.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25001_001E",
          commonName: "Total Existing Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25001?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
    {
      sourceName: SOURCES["BPS"].sourceName,
      datasetName: SOURCES["BPS"].datasetName,
      datasetLink: SOURCES["BPS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "Newly Permitted Housing Units",
          commonName: "Newly Permitted Housing Units",
          url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
        },
      ],
    },
  ],
  metricDefinition: "The annual percentage increase in total housing units. Measures how quickly a city is expanding its housing supply to meet current or future demand.",
  calculationFormula:
    "(((Total Existing Housing Units¹ + Newly Permited Housing Units²) / Total Existing Housing Units¹) - 1) * 100",
};

const multiFamilyShareData = {
  aboutDescription: "The percentage of homes in multifamily buildings (e.g. apartments, condos). Higher values suggest more rental availability and density, often associated with affordability and urban living.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25034_001E",
          commonName: "Total Units Built All Time",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_004E",
          commonName: "Existing Units in 2-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_005E",
          commonName: "Existing Units in 3-to-4-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_006E",
          commonName: "Existing Units in 5-to-9-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_007E",
          commonName: "Existing Units in 10-to-19-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_008E",
          commonName: "Existing Units in 20-to-49-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_009E",
          commonName: "Existing Units in 50-Plus-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        }
      ],
    },
  ],
  metricDefinition: "The percentage of homes in multifamily buildings (e.g. apartments, condos). Higher values suggest more rental availability and density, often associated with affordability and urban living.",
  calculationFormula:
  "(Total Units in Existing Structures with More Than 1 Unit¹) / (Total Existing Housing Units¹) * 100",
};

const rentalVacancyRateData = {
  aboutDescription: "This metric tracks the median housing age in years.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25004_003E",
          commonName: "Vacant Units for Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25004?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25003_003E",
          commonName: "Renter Occupied Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25004_006E",
          commonName: "Unoccupied Units with a Signed Lease",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25004?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The percentage of rental units that are unoccupied and available. Lower rates suggest tight rental markets and reduced availability, potentially driving up rents.",
  calculationFormula:
  "((Vacant Units for Rent¹ + Unoccupied Units with a Signed Lease²) / (Renter Occupied Housing Units³ + Vacant Units for Rent¹ + Unoccupied Units with a Signed Lease²)) * 100",
}

const totalPopulationData = {
  aboutDescription: "This metric tracks the total population.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The total number of residents. Population size is a fundamental driver of housing demand.",
  calculationFormula: "Absolute value from the American Community Survey (ACS). Change Year over Year was calculated using the Compound Annual Growth Rate (CAGR) formula."
};

const housingStockPotentialData = {
    aboutDescription: "This metric tracks the total number of housing units.",
    sources: [
        {
            sourceName: SOURCES["ACS"].sourceName,
            datasetName: SOURCES["ACS"].datasetName,
            datasetLink: SOURCES["ACS"].datasetLink,
            retrievedOn: "June 2, 2025",
            variables: [
                {
                    name: "B25001_001E",
                    commonName: "Total Existing Housing Units",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25001?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
            ],
        },
        {
          sourceName: SOURCES["BPS"].sourceName,
          datasetName: SOURCES["BPS"].datasetName,
          datasetLink: SOURCES["BPS"].datasetLink,
          retrievedOn: "June 2, 2025",
          variables: [
            {
              name: "Newly Permitted Housing Units",
              commonName: "Newly Permitted Housing Units",
              url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
            },
          ],
        },
    ],
    metricDefinition: "The annual percentage increase in total housing units. Measures how quickly a city is expanding its housing supply to meet current or future demand.",
    calculationFormula:
      "(((Total Existing Housing Units¹ +  Newly Permited Housing Units²) / (Total Existing Housing Units¹) - 1) * 100)",
}

const unbuiltPermittedUnitsData = {
    aboutDescription: "This metric tracks the number of housing units that have been permitted but not yet built.",
    sources: [
        {
            sourceName: SOURCES["BPS"].sourceName,
            datasetName: SOURCES["BPS"].datasetName,
            datasetLink: SOURCES["BPS"].datasetLink,
            retrievedOn: "June 2, 2025",
            variables: [
                {
                    name: "Newly Permitted Housing Units",
                    commonName: "Newly Permitted Housing Units",
                    url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
                },
            ],
        },
    ],
    metricDefinition: "The number of housing units that have been permitted but are not yet recorded as built. This represents potential future housing supply.",
    calculationFormula: "Newly Permitted Housing Units²",
}

const housingStockByDecadeData = {
    aboutDescription: "This metric shows the breakdown of housing stock by the decade it was built.",
    sources: [
        {
            sourceName: SOURCES["ACS"].sourceName,
            datasetName: SOURCES["ACS"].datasetName,
            datasetLink: SOURCES["ACS"].datasetLink,
            retrievedOn: "June 2, 2025",
            variables: [
                {
                    name: "B25034_002E",
                    commonName: "Total Units Built 2014 or Later",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_003E",
                    commonName: "Total Units Built Between 2010 and 2013",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_004E",
                    commonName: "Total Units Built Between 2000 and 2009",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_005E",
                    commonName: "Total Units Built Between 1990 and 1999",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_006E",
                    commonName: "Total Units Built Between 1980 and 1989",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_007E",
                    commonName: "Total Units Built Between 1970 and 1979",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_008E",
                    commonName: "Total Units Built Between 1960 and 1969",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_009E",
                    commonName: "Total Units Built Between 1950 and 1959",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_010E",
                    commonName: "Total Units Built Between 1940 and 1949",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25034_011E",
                    commonName: "Total Units Built 1939 or Earlier",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
            ],
        },
    ],
    metricDefinition: "The age distribution of housing units by decade built. This provides insight into the history of housing development in the jurisdiction.",
    calculationFormula: "Absolute value from the American Community Survey (ACS).",
}

const priceToIncomeRatioData = {
  aboutDescription: "This metric tracks the percentage of existing housing units that are multi-family (2+ Units in Structure).",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25077_001E",
          commonName: "Median Home Value",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25077?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B19013_001E",
          commonName: "Median Household Income",
          url: "https://data.census.gov/table/ACSDT5Y2023.B19013?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The ratio of median home value to median household income. A higher ratio signals reduced homeownership affordability and potential housing cost burden.",
  calculationFormula:
  "(Median Home Value¹ / Median Household Income²)",
};

const rentalBurdenShareData = {
  aboutDescription: "This metric tracks the median housing age in years.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25070_007E",
          commonName: "Renters Paying 30 to 34.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_008E",
          commonName: "Renters Paying 35 to 39.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_009E",
          commonName: "Renters Paying 40 to 49.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_010E",
          commonName: "Renters Paying 50+ Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25003_003E",
          commonName: "Renter Occupied Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25003?d=ACS+5-Year+Estimates+Detailed+Tables",
        }
      ],
    },
  ],
  metricDefinition: "The share of renters spending more than 30% of income on rent. Indicates rental affordability pressure; higher values mean more households are financially strained.",
  calculationFormula:
  "((Renters Paying 30 to 34.9 Pct of Income as Rent¹ + Renters Paying 35 to 39.9 Pct of Income as Rent² + Renters Paying 40 to 49.9 Pct of Income as Rent³ + Renters Paying 50+ Pct of Income as Rent⁴) / (Renter Occupied Housing Units¹)) * 100",
}

const housingStockCompositionData = {
    aboutDescription: "This metric shows the composition of the housing stock by structure type.",
    sources: [
        {
            sourceName: SOURCES["ACS"].sourceName,
            datasetName: SOURCES["ACS"].datasetName,
            datasetLink: SOURCES["ACS"].datasetLink,
            retrievedOn: "June 2, 2025",
            variables: [
                {
                  name: "B25001_001E",
                  commonName: "Total Existing Housing Units",
                  url: "https://data.census.gov/table/ACSDT5Y2023.B25001?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_002E",
                    commonName: "Existing Units in 1-Unit, Detached Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_003E",
                    commonName: "Existing Units in 1-Unit, Attached Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_004E",
                    commonName: "Existing Units in 2-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_005E",
                    commonName: "Existing Units in 3-to-4-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_006E",
                    commonName: "Existing Units in 5-to-9-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_007E",
                    commonName: "Existing Units in 10-to-19-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_008E",
                    commonName: "Existing Units in 20-to-49-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
                {
                    name: "B25024_009E",
                    commonName: "Existing Units in 50-Plus-Unit Structures",
                    url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
                },
            ],
        },
    ],
    metricDefinition: "The breakdown of housing units by structure type. This shows the diversity of housing options available.",
    calculationFormula: "Absolute value from the American Community Survey (ACS). Share of each housing type relative to total housing units was calculated by ( Housing Stock of Specific Number of Units in Structure² ) / ( Total Existing Housing Units¹ ) * 100",
}

export const snapshotMetricDefs = {
    //row 1
    "Total Population": totalPopulationData,
    "Housing Stock Potential": housingStockPotentialData,
    "Unbuilt Permitted Units": newlyPermittedUnitsData,

    //row 2
    "Population Growth": populationGrowthData,
    "Housing Stock Growth": housingStockGrowthData,

    //row 3
    "Price to Income Ratio": priceToIncomeRatioData,
    "Rental Vacancy Rate": rentalVacancyRateData,
    "Multi Family Share": multiFamilyShareData,

    //row 4
    "Housing Stock by Decade": housingStockByDecadeData,
    "Housing Stock Composition": housingStockCompositionData,
}